import { useState, useEffect } from 'react';

/**
 * Custom hook for detecting mobile/tablet devices
 * Combines user agent detection, touch capability, and screen size
 */
export function useIsMobile(): boolean {
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const detectMobile = () => {
            // Check user agent for mobile devices
            const mobileUA = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
            
            // Check for iPad specifically (including newer iPads that report as Mac)
            const isIpad = /iPad|Macintosh/i.test(navigator.userAgent) && 'ontouchstart' in window;
            
            // Check for touch capability and screen size
            const hasTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
            const smallScreen = window.innerWidth <= 1024; // Include tablets
            
            return mobileUA || isIpad || (hasTouch && smallScreen);
        };

        const handleResize = () => {
            setIsMobile(detectMobile());
        };

        // Initial detection
        setIsMobile(detectMobile());

        // Listen for window resize events to handle orientation changes
        window.addEventListener('resize', handleResize);
        
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return isMobile;
}